export default {"src":"https://www.adfcareers.gov.au/_next/static/media/chevron-up.fbe05ba6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};